import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private readonly mapPreferencesKey = 'mapPreferences';

  // Sauvegarde des préférences dans le localStorage
  saveMapPreferences(preferences: any) {
    localStorage.setItem(this.mapPreferencesKey, JSON.stringify(preferences));
  }

  // Récupération des préférences depuis le localStorage
  getMapPreferences(): { center: [number, number], zoom: number } | null {
    const savedPreferences = localStorage.getItem(this.mapPreferencesKey);
    if (savedPreferences) {
      return JSON.parse(savedPreferences);
    }
    return null;
  }

  // Vérifie si des préférences sont sauvegardées
  hasMapPreferences() {
    return !!localStorage.getItem(this.mapPreferencesKey);
  }
}
